export function addScrollLock(selector: string, keepScrollBarGap = false) {
  global.document.querySelector(selector)?.classList.add('scroll-lock');
  if (keepScrollBarGap) {
    global.document.querySelector(selector)?.classList.add('[scrollbar-gutter:stable]');
  }
}

export function removeScrollLock(selector: string) {
  global.document.querySelector(selector)?.classList.remove('scroll-lock');
  global.document.querySelector(selector)?.classList.remove('[scrollbar-gutter:stable]');
}
